import * as emptyImageDataResolver from './emptyImageDataResolver'
import * as pageLinkDataResolver from './pageLinkDataResolver'
import * as vectorImageDataResolver from './vectorImageDataResolver'

export {
    emptyImageDataResolver,
    pageLinkDataResolver,
    vectorImageDataResolver
}
